module.exports = __webpack_public_path__ + "static/Homonculous-782c71e0c7ad9fd383deae7f7bffbebf.jpg";